import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import trans from 'translate';
import { capitalize } from 'services/utilsService';
import TokenWithNetwork from '../../TokenWithNetwork/TokenWithNetwork';
import TokenVerifiedOnTokenLists from '../../TokenVerifiedOnTokenLists/TokenVerifiedOnTokenLists';

import './TokenListsSearchResult.scss';

const TokenListsSearchResult = ({ token, handleSearchResultClick }) => {
  const tokenNetwork = useMemo(() => capitalize(token.network), [token.network]);

  const handleSearchResultClickCallback = useCallback(
    () => handleSearchResultClick(token),
    [token, handleSearchResultClick],
  );

  return (
    <div className="token-lists-search-result-wrapper" onClick={handleSearchResultClickCallback}>
      <TokenWithNetwork token={token} />

      <div className="data-wrapper">
        <div className="name">{trans('pools.token_on_network', { token: token.symbol, network: tokenNetwork })}</div>

        <div className="address">{token.address}</div>

        <TokenVerifiedOnTokenLists token={token} />
      </div>
    </div>
  );
};

TokenListsSearchResult.propTypes = {
  token: PropTypes.object.isRequired,
  handleSearchResultClick: PropTypes.func.isRequired,
};

export default TokenListsSearchResult;
